document.querySelector("section").addEventListener("scroll", function () {
  const scrolledScreen = document.querySelector("section").scrollTop;
  const headerHeight = document.querySelector("header").clientHeight;
  if (scrolledScreen > headerHeight) {
    document.querySelector("header").classList.add("active");
    document
      .querySelector("header img")
      .setAttribute("srcset", "//majik.in/cdn/shop/t/15/assets/majik-logo-color.png?v=78056658803124283061772808675");
  } else {
    document.querySelector("header").classList.remove("active");
    document
      .querySelector("header img")
      .setAttribute("srcset", "//majik.in/cdn/shop/t/15/assets/majik-logo.png?v=136570366162235047701772808675");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const hero = document.querySelector(".hero-section");
  const canvas = document.getElementById("snow-canvas");

  if (!hero || !canvas) return; // VERY IMPORTANT

  const ctx = canvas.getContext("2d");
  let width, height;
  let snowflakes = [];

  function resizeCanvas() {
    width = hero.offsetWidth;
    height = hero.offsetHeight;
    canvas.width = width;
    canvas.height = height;
  }

  function createSnowflakes() {
    snowflakes = [];
    const count = Math.floor(width / 15);

    for (let i = 0; i < count; i++) {
      snowflakes.push({
        x: Math.random() * width,
        y: Math.random() * height,
        r: Math.random() * 2 + 1,
        d: Math.random() * 1 + 0.5,
        speed: Math.random() * 0.5 + 0.2
      });
    }
  }

  function drawSnow() {
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = "rgba(255,255,255,0.7)";
    ctx.beginPath();

    snowflakes.forEach(flake => {
      ctx.moveTo(flake.x, flake.y);
      ctx.arc(flake.x, flake.y, flake.r, 0, Math.PI * 2);
    });

    ctx.fill();
    moveSnow();
  }

  function moveSnow() {
    snowflakes.forEach(flake => {
      flake.y += flake.speed;
      flake.x += Math.sin(flake.d);

      if (flake.y > height) {
        flake.y = -5;
        flake.x = Math.random() * width;
      }
    });
  }

  function animateSnow() {
    drawSnow();
    requestAnimationFrame(animateSnow);
  }

  window.addEventListener("resize", () => {
    resizeCanvas();
    createSnowflakes();
  });

  resizeCanvas();
  createSnowflakes();
  animateSnow();
});
